export const AppDownloadsIcon = () => {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.4"
                d="M51.25 25.475H44.025C38.1 25.475 33.275 20.65 33.275 14.725V7.5C33.275 6.125 32.15 5 30.775 5H20.175C12.475 5 6.25 10 6.25 18.925V41.075C6.25 50 12.475 55 20.175 55H39.825C47.525 55 53.75 50 53.75 41.075V27.975C53.75 26.6 52.625 25.475 51.25 25.475Z"
                fill="#13C2C2"
            />
            <path
                d="M39.5002 5.5262C38.4752 4.5012 36.7002 5.2012 36.7002 6.6262V15.3512C36.7002 19.0012 39.8002 22.0262 43.5752 22.0262C45.9502 22.0512 49.2502 22.0512 52.0752 22.0512C53.5002 22.0512 54.2502 20.3762 53.2502 19.3762C49.6502 15.7512 43.2002 9.2262 39.5002 5.5262Z"
                fill="#13C2C2"
            />
            <path
                d="M30.7001 36.8C29.9751 36.075 28.7751 36.075 28.0501 36.8L26.2501 38.6V28.125C26.2501 27.1 25.4001 26.25 24.3751 26.25C23.3501 26.25 22.5001 27.1 22.5001 28.125V38.6L20.7001 36.8C19.9751 36.075 18.7751 36.075 18.0501 36.8C17.3251 37.525 17.3251 38.725 18.0501 39.45L23.0501 44.45C23.0751 44.475 23.1001 44.475 23.1001 44.5C23.2501 44.65 23.4501 44.775 23.6501 44.875C23.9001 44.95 24.1251 45 24.3751 45C24.6251 45 24.8501 44.95 25.0751 44.85C25.3001 44.75 25.5001 44.625 25.7001 44.45L30.7001 39.45C31.4251 38.725 31.4251 37.525 30.7001 36.8Z"
                fill="#13C2C2"
            />
        </svg>
    );
};
